export default "__VITE_PUBLIC_ASSET__13a37a5b__"